<template>
  <div>
    <Fob type="Secondary" @click="toggleLegend">
      <i class="fa-regular fa-circle-info w-4" />
    </Fob>
    <ScheduleLegend v-if="open" @hide-modal="toggleLegend" />
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

import Fob from "@/components/Seranova/Fobs/Fob.vue";
import ScheduleLegend from "./ScheduleLegend.vue";
const open = ref(false);
const toggleLegend = () => (open.value = !open.value);
</script>
